import { useEffect, useState, useRef } from "react";

// Chat-style typing: pulsing "···" indicator, then text streams in char-by-char.
export const TypingBubble = ({ text, onDone, speed = 18, thinkMs = 650, testId }) => {
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;
  const [phase, setPhase] = useState("dots"); // dots -> typing -> done
  const [shown, setShown] = useState("");
  const doneRef = useRef(false);

  useEffect(() => {
    setPhase("dots"); setShown(""); doneRef.current = false;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let t1, interval;
    t1 = setTimeout(() => {
      if (reduce) {
        setShown(text); setPhase("done");
        if (!doneRef.current) { doneRef.current = true; onDoneRef.current && onDoneRef.current(); }
        return;
      }
      setPhase("typing");
      let i = 0;
      interval = setInterval(() => {
        i += 1;
        setShown(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(interval);
          setPhase("done");
          if (!doneRef.current) { doneRef.current = true; onDoneRef.current && onDoneRef.current(); }
        }
      }, speed);
    }, thinkMs);
    return () => { clearTimeout(t1); clearInterval(interval); };
  }, [text, speed, thinkMs]);

  return (
    <div className="flex items-end gap-2" data-testid={testId}>
      <img src="/mindmoves-mark.png" alt="" className="w-7 h-7 object-contain shrink-0" />
      <div className="max-w-[80%] rounded-2xl rounded-bl-md bg-slate-100 px-4 py-3 text-slate-800 text-[15px] leading-relaxed">
        {phase === "dots" ? (
          <span className="flex items-center gap-1 py-1">
            <span className="mm-dot animate-blink" />
            <span className="mm-dot animate-blink" style={{ animationDelay: "0.2s" }} />
            <span className="mm-dot animate-blink" style={{ animationDelay: "0.4s" }} />
          </span>
        ) : (
          <span>{shown}</span>
        )}
      </div>
    </div>
  );
};

export default TypingBubble;
